import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Collaborator } from '../Collaborator.ts';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';

export function useDeleteCollaboratorMutations() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [QueryKeys.collaborators, QueryKeys.collaborator],
        mutationFn: async ({ id }: { id: string }) => {
            return CollaboratorApi.deleteCollaborator(id);
        },
        onSuccess: (_, { id }: { id: string }) => {
            queryClient.setQueryData<Collaborator[]>(
                [QueryKeys.collaborators],
                (prev) => prev?.filter((collaborator) => collaborator.id!.toString() !== id) ?? [],
            );

            queryClient.invalidateQueries({ queryKey: [QueryKeys.collaborator, id] });
        },
    });
}
